<template>
  <div class="user">
    <CreateOrEditUser ref="createOrEditDialog" :roleList="roleList" @submitDialog="GetTableList" />
    <CreateOrEditTenant ref="createOrEditTenant" @submitDialog="GetTableList" />
    <JoinMember ref="joinMember" @submitDialog="GetTableList" />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>平台用户</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <!-- <el-button
          v-if="$store.getters.checkPermission('report.get')"
          type="primary"
          size="small"
          @click="exportUserData"
          >导出报表</el-button
        > -->
        <el-button
          v-if="$store.getters.checkRole(3004) || $store.getters.checkRole(30041) || $store.getters.checkRole(3005) || $store.getters.checkRole(30051)"
          type="primary" icon="el-icon-plus" size="small" @click="CreateItem">{{ l("新增") }}</el-button>
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="3">
          <label>昵称</label>
          <el-input :placeholder="l('请输入') + l('内容')" v-model="SearchData.name" clearable @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"></el-input>
        </el-col>
        <el-col :span="3">
          <label>账号</label>
          <el-input :placeholder="l('请输入') + l('内容')" v-model="SearchData.mobile" clearable @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"></el-input>
        </el-col>
        <el-col :span="3">
          <label>主营业务</label>
          <el-select clearable v-model="SearchData.pre_business_tag_id" @change="GetTableList(true)">
            <el-option-group>
              <el-option label="未配置" :value="0"></el-option>
            </el-option-group>
            <el-option-group>
              <el-option v-for="item of $store.state.basicInfo.tagList.pre_business" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="3">
          <label>企业</label>
          <el-select v-model="SearchData.tenant_id" filterable clearable remote reserve-keyword placeholder="请输入企业名"
            :remote-method="remoteMethod" @change="GetTableList(true)">
            <el-option-group>
              <el-option label="未认证" :value="0"></el-option>
            </el-option-group>

            <el-option-group>
              <el-option v-for="item in tenant_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="3">
          <label>主/子账号</label>
          <el-select clearable v-model="customSearchData.role_2" @change="GetTableList(true)">
            <el-option v-for="item of roleList.filter((item) => item.type == 2)" :key="item.id"
              :label="item.display_name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <label>市场业务员</label>
          <el-select clearable v-model="SearchData.manager_shichang_id" @change="GetTableList(true)">
            <el-option-group>
              <el-option label="未分配" :value="0"></el-option>
            </el-option-group>
            <el-option-group>
              <el-option v-for="item of manager_shichangList" :key="item.id" :label="item.display_name"
                :value="item.id"></el-option>
            </el-option-group>
          </el-select>
        </el-col>

        <el-col :span="3">
          <label>采购业务员</label>
          <el-select clearable v-model="SearchData.manager_caigou_id" @change="GetTableList(true)">
            <el-option-group>
              <el-option label="未分配" :value="0"></el-option>
            </el-option-group>
            <el-option-group>
              <el-option v-for="item of manager_caigouList" :key="item.id" :label="item.display_name"
                :value="item.id"></el-option>
            </el-option-group>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-button type="primary" icon="el-icon-search" round @click="GetTableList(true)">{{ l("查询") }}</el-button>
        </el-col>
      </el-row>

      <el-table :data="TableList" :stripe="true" @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange">
        <TableOperation :operationList="[
          {
            is_show: (row) =>
              this.$store.getters.checkPermission('admin_user.edit'),
            label: l('详情'),
            command: 'ViewItem',
          },
          {
            is_show: (row) => row.status == 1 && row.id != $store.state.session.user.id,
            label: '模拟登录',
            command: 'simulate',
          },
          {
            is_show: (row) =>
              this.$store.getters.checkPermission('admin_user.edit') &&
              row.status == 1,
            label: '冻结账号',
            command: 'disableItem',
          },
          {
            is_show: (row) =>
              this.$store.getters.checkPermission('admin_user.edit') &&
              row.status == 0,
            label: '解冻账号',
            command: 'enableItem',
          },
          {
            is_show: (row) =>
              this.$store.getters.checkPermission('admin_user.edit') &&
              this.$store.getters.checkPermission('admin_tenant.get') &&
              !row.tenant,
            label: '加入企业',
            command: 'show_join',
          },
          {
            // 重置密码
            is_show: (row) =>
              this.$store.getters.checkPermission('admin_user.edit'),
            label: '重置密码',
            command: 'resetPassword',
          }
        ]" @handleOperation="HandleOperation" />
        <el-table-column prop="name" label="昵称" width="120" fixed>
          <el-table-column prop="mobile" label="手机号" width="120" fixed show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{ scope.row.display_name }}</div>
              <div>{{ scope.row.mobile }}</div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="头像" width="100">
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <div class="ImageInTable">
                <el-image v-if="scope.row.avatar" :src="scope.row.avatar" fit="contain"
                  :preview-src-list="[scope.row.avatar]"></el-image>
              </div>
              <div style="position: relative; z-index: 1; margin-top: 35px">
                <div v-if="scope.row.status == 1" class="color-success">
                  正常
                </div>
                <div v-else class="color-danger">冻结</div>
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="主营业务" width="140">
          <template slot-scope="scope">
            <template v-if="
              ($store.getters.checkRole(3004) || $store.getters.checkRole(30041) || $store.getters.checkRole(3005) || $store.getters.checkRole(30051)) &&
              $store.state.session.user.id == scope.row.id
            ">
              平台业务员
            </template>
            <template v-else>
              <el-select v-model="scope.row.pre_business_tag_id" size="mini"
                :disabled="!$store.getters.checkPermission('admin_user.edit')"
                @change="changePreBussinessTag(scope.row)">
                <el-option v-for="pre_business_tag of $store.state.basicInfo.tagList
                  .pre_business" :key="pre_business_tag.id" :label="pre_business_tag.name"
                  :value="pre_business_tag.id"></el-option>
              </el-select>
            </template>

          </template>
        </el-table-column>

        <el-table-column label="市场业务员" width="140">
          <el-table-column label="采购业务员" width="140">
            <template slot-scope="scope">
              <div>
                <el-select v-model="scope.row.manager_shichang_id" size="mini" :disabled="!$store.getters.checkPermission('admin_user.edit')
                  " @change="changeManager_shichang(scope.row)">
                  <el-option-group>
                    <el-option v-for="manager of manager_shichangList" :key="manager.id" :label="manager.display_name"
                      :value="manager.id"></el-option>
                  </el-option-group>
                  <el-option-group>
                    <el-option label="-" :value="null"></el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div style="margin-top: 4px">
                <el-select v-model="scope.row.manager_caigou_id" size="mini" :disabled="!$store.getters.checkPermission('admin_user.edit')
                  " @change="changeManager_caigou(scope.row)">
                  <el-option-group>
                    <el-option v-for="manager of manager_caigouList" :key="manager.id" :label="manager.display_name"
                      :value="manager.id"></el-option>
                  </el-option-group>
                  <el-option-group>
                    <el-option label="-" :value="null"></el-option>
                  </el-option-group>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="所属企业" width="150" show-overflow-tooltip>
          <el-table-column label="主/子账号" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link v-if="scope.row.tenant" type="warning" @click="viewTenant(scope.row)">
                {{ scope.row.tenant.name }}
              </el-link>
              <template v-else>
                <div style="color: #ccc">
                  {{ scope.row.pre_company_name }}
                </div>
              </template>
              <div>
                {{ getRole(2, scope.row) }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="信用等级" width="110">
          <template slot-scope="scope">
            <div style="display: flex;">
              <div v-for="(item, index) in 5" :key="index">
                <el-image v-if="scope.row.tenant && index < scope.row.tenant.credit_rating"
                  style="width:18px; height:18px" :src="GetResourceUrl('backend/icon-star.svg')"></el-image>
                <el-image v-else style="width:18px; height:18px"
                  :src="GetResourceUrl('backend/icon-star-un.svg')"></el-image>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="170">
          <el-table-column label="上次访问" width="170">
            <template slot-scope="scope">
              <div>{{ scope.row.created_time }}</div>
              <div>{{ scope.row.last_visit_time }}</div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="供应商权限" width="280">
          <el-table-column label="采购商权限" width="280">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center;">
                <el-image style="width:18px; height:18px;" :src="GetResourceUrl('backend/SJT.svg')"></el-image>
                <div style="margin:0 6px;">商机通</div>

                <div v-if="scope.row.member_quotation_level">
                  {{ scope.row.member_quotation_start_time.slice(0, 10) }} ~
                  {{ scope.row.member_quotation_end_time.slice(0, 10) }}
                </div>
                <template v-else>
                  <el-button v-if="$store.getters.checkRole(3001) || $store.getters.checkRole(3002)" type="primary"
                    size="mini" @click="joinMemberQuotation(scope.row, 'quotation')">开通</el-button>
                  <div v-else style="color:#999">暂未开通</div>
                </template>
              </div>
              <div style="display: flex;align-items: center;justify-content: center;margin-top:6px;">
                <el-image style="width:18px; height:18px;" :src="GetResourceUrl('backend/SCT.svg')"></el-image>
                <div style="margin:0 6px;">速采通</div>

                <div v-if="scope.row.member_purchase_level">
                  {{ scope.row.member_purchase_start_time.slice(0, 10) }} ~
                  {{ scope.row.member_purchase_end_time.slice(0, 10) }}
                </div>
                <template v-else>
                  <el-button v-if="$store.getters.checkRole(3001) || $store.getters.checkRole(3002)" type="primary"
                    size="mini" @click="joinMemberQuotation(scope.row, 'purchase')">开通</el-button>
                  <div v-else style="color:#999">暂未开通</div>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 表示用小程序登录过 -->
        <el-table-column label="绑定小程序" width="100">
          <el-table-column label="关注公众号" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.openid" class="color-success">是</div>
              <div v-else class="color-danger">否</div>

              <div v-if="scope.row.is_subscribe" class="color-success">是</div>
              <div v-else class="color-danger">否</div>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column prop="source" label="来源" width="200">
          <el-table-column prop="country" label="国家/地区" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.source }}</div>
              <div>{{$store.state.basicInfo.countryList.find(item => item.code == scope.row.country).cnName}}</div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="HandleSizeChange" @current-change="HandleCurrentChange"
        :current-page="CurrentPage" :page-sizes="PageSizeList" :page-size="PageSize"
        layout="total, prev, pager, next, jumper" :total="TotalCount"></el-pagination>
    </div>

    <el-dialog v-if="showJoinDialog" width="720px" title="加入企业（成为子账号）" :visible.sync="showJoinDialog"
      :destroy-on-close="true">
      <el-select v-model="join_tenant_id" filterable clearable remote reserve-keyword placeholder="请输入企业名"
        :remote-method="remoteMethod2">
        <el-option v-for="item in tenant_list" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showJoinDialog = false">{{ l("取 消") }}</el-button>
        <el-button type="danger" @click="join">{{ l("确 定") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditUser from "./operation/CreateOrEditUser.vue";
import CreateOrEditTenant from "@/views/admin_tenant/operation/CreateOrEditTenant.vue";
import JoinMember from "./operation/JoinMember.vue";

export default {
  name: "User",
  components: {
    CreateOrEditUser,
    CreateOrEditTenant,
    JoinMember
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        name: "",
        mobile: "",
        tenant_id: "",
        source: "",
        pre_business_tag_id: "",
        manager_shichang_id: "",
        manager_caigou_id: "",
      },
      tenant_list: [],
      customSearchData: {
        role_1: "",
        role_2: "",
        role_3: "",
      },
      roleList: [],
      manager_shichangList: [],
      manager_caigouList: [],

      showJoinDialog: false,
      join_tenant_id: "",
      join_user_id: "",
    };
  },
  created() {
    this.SearchData.tenant_id = this.$route.query.tenant_id;
    this.remoteMethod();
    this.axios
      .get("/api/role/", {
        params: {
          // type: 3, //1注册用户 2前台 3后管
        },
      })
      .then((data) => {
        this.roleList = data;
      });

    this.axios
      .get("/api/admin_user/backend_user_simple_list/", {
        params: {
          role: "3004,30041" //业务员-市场
        },
      })
      .then((data) => {
        this.manager_shichangList = data;
      });

    this.axios
      .get("/api/admin_user/backend_user_simple_list/", {
        params: {
          role: "3005,30051" //业务员-采购
        },
      })
      .then((data) => {
        this.manager_caigouList.push(...data);
      });
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      var role_list = [];
      if (this.customSearchData.role_1)
        role_list.push(this.customSearchData.role_1);
      if (this.customSearchData.role_2)
        role_list.push(this.customSearchData.role_2);
      if (this.customSearchData.role_3)
        role_list.push(this.customSearchData.role_3);

      this.axios
        .get("/api/admin_user/", {
          params: {
            ...this.SearchData,
            role: role_list.join(","),
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    enableItem(item) {
      this.$confirm(`是否解冻用户【${item.mobile}】`, "", {
        type: "warning",
      }).then(() => {
        this.axios.put(`/api/admin_user/${item.id}/enable/`).then(() => {
          this.GetTableList();
        });
      });
    },
    disableItem(item) {
      this.$confirm(
        "冻结后该用户将无法登录平台",
        `冻结用户【${item.mobile}】`,
        {
          type: "warning",
        }
      ).then(() => {
        this.axios.put(`/api/admin_user/${item.id}/disable/`).then(() => {
          this.GetTableList();
        });
      });
    },
    getRole(type, row) {
      for (var role_id of row.role_list) {
        for (var role of this.roleList.filter((role) => role.type == type)) {
          if (role.id == role_id) {
            return role.display_name;
          }
        }
      }
    },
    viewTenant(item) {
      this.$refs.createOrEditTenant.Type = "View";
      this.$refs.createOrEditTenant.Show({ id: item.tenant_id });
    },
    remoteMethod(query) {
      this.axios
        .get("/api/admin_tenant/simple_list/", {
          params: {
            name: query,
            size: 20,
          },
        })
        .then((data) => {
          this.tenant_list = data.results;
        });
    },

    // exportUserData() {
    //   this.axios.get("/api/report/export_user_data/");
    // },
    joinMemberQuotation(user, mode) {
      this.$refs.joinMember.id = user.id;
      this.$refs.joinMember.mode = mode;
      this.$refs.joinMember.Show();
    },
    simulate(item) {
      if (this.$store.state.session.host_token) {
        this.$message.error("已处于模拟登录状态，请勿重复操作");
        return;
      }

      this.axios
        .post("/api/simulate_login/", { user_id: item.id })
        .then((response) => {
          var old_token = this.$localStorage.get("token");
          this.$localStorage.set("host_token", old_token);
          this.$store.setSession("host_token", old_token);

          if (this.$store.getters.checkRole(3001) || this.$store.getters.checkRole(3002)) {
            this.$localStorage.set("host_token_admin", 1);
            this.$store.setSession("host_token_admin", 1);
          } else {
            this.$localStorage.set("host_token_admin", 2);
            this.$store.setSession("host_token_admin", 2);
          }

          this.$localStorage.set("token", response);
          this.$store.setSession("token", response);
          setTimeout(() => {
            //保证在finally之后执行
            this.$store.dispatch("updateSession").then(() => {
              this.$store.commit("updateUnreadNotify");
              this.$router.push({ path: "/" });
            });
          });
        });
    },
    show_join(item) {
      this.join_user_id = item.id;
      this.join_tenant_id = "";
      this.showJoinDialog = true;
      this.remoteMethod2();
    },
    resetPassword(item) {
      this.$confirm(
        `是否将该帐号【${item.display_name}】密码重置为 111111 ?`,
        "重置密码",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .put(`/api/admin_user/${item.id}/reset_password/`)
            .then((response) => {

            });
        });
    },
    join() {
      this.axios
        .put(`/api/admin_user/${this.join_user_id}/join_sub/`, {
          tenant_id: this.join_tenant_id,
        })
        .then(() => {
          this.showJoinDialog = false;
          this.GetTableList();
        });
    },

    remoteMethod2(query) {
      this.axios
        .get("/api/admin_tenant/simple_list/", {
          params: {
            name: query,
            size: 20,
          },
        })
        .then((data) => {
          this.tenant_list = data.results;
        });
    },

    changePreBussinessTag(item) {
      this.$confirm(
        "修改后将自动重新分配业务员",
        `是否修改【${item.display_name}】的主营业务?`,
        {
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .put(`/api/admin_user/${item.id}/edit_pre_business_tag/`, {
              pre_business_tag_id: item.pre_business_tag_id,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },

    changeManager_shichang(item) {

      if (!item.manager_shichang_id) {
        return this.clear_manager(item, "shichang");
      }

      const manager_name = this.$utils.listFilter(
        this.manager_shichangList,
        item.manager_shichang_id,
        "display_name"
      );

      this.$confirm(`手动指定市场业务员为【${manager_name}】?`, "是否确定", {
        type: "warning",
      })
        .then(() => {
          this.axios
            .put(`/api/admin_user/${item.id}/edit_manager/`, {
              manager_id: item.manager_shichang_id,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },
    changeManager_caigou(item) {
      if (!item.manager_caigou_id) {
        return this.clear_manager(item, "caigou");
      }

      const manager_name = this.$utils.listFilter(
        this.manager_caigouList,
        item.manager_caigou_id,
        "display_name"
      );

      this.$confirm(`手动指定采购业务员为【${manager_name}】?`, "是否确定", {
        type: "warning",
      })
        .then(() => {
          this.axios
            .put(`/api/admin_user/${item.id}/edit_manager/`, {
              manager_id: item.manager_caigou_id,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },
    clear_manager(item, manager_type) {
      let manager_type_name;
      if (manager_type == "shichang") {
        manager_type_name = "市场业务员";
      } else if (manager_type == "caigou") {
        manager_type_name = "采购业务员";
      }
      this.$confirm(`清除用户【${item.display_name}】的${manager_type_name}?`, "是否确定", {
        type: "warning",
      })
        .then(() => {
          this.axios
            .put(`/api/admin_user/${item.id}/clear_manager/`, {
              manager_type
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    }
  },
};
</script>


<style scoped lang="scss"></style>
